import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, TextStyle } from 'editor/src/store/design/types';

const addTextStyleReducer = (state: DesignState, action: PayloadAction<TextStyle>) => {
  if (!state.designData) {
    return;
  }
  const styles = state.designData.textStyles ?? [];
  if (styles.some((style) => style.id === action.payload.id)) {
    return;
  }
  state.designData.textStyles = [...styles, action.payload];
};

export default addTextStyleReducer;
